import { RxStorage } from "@rx/storage";
import { Injectable, Inject, ReflectiveInjector } from "@angular/core"

const DOT_CHARACTER = ".";
export class ApplicationConfiguration {
    //Ishani
    private static storage: RxStorage;
    private static injector: any;
    public static Init() {
        if (!this.storage) {
            this.injector = ReflectiveInjector.resolveAndCreate([RxStorage]);
            this.storage = this.injector.get(RxStorage);
        }
    }
    //Ishani

    public static set(jObject: any): void {
        this.configuration = jObject;
        this.configuration.cachedKeys = this.cachedKeys;
    }

    public static setLanguages(languages: any): void {
        this.configuration.languages = languages;
    }

    public static setDefaultLanguage(languageName: string): void {
        //Ishani
        this.Init();
        this.storage.local.save("defaultLanguage", languageName);
        if (languageName)
            this.configuration.defaultLanguage = languageName;
        //Ishani
    }

    //Ishani
    public static getDefaultLanguage(): string {
        this.Init();
        return this.storage.local.get("defaultLanguage") || "English";
    }
    //Ishani

    public static get(key: string): any {
        if (!this.configuration) return;
        var currentObject = this.configuration;
        let props = key.split(DOT_CHARACTER);
        for (let prop of props) {
            currentObject = currentObject[prop]
            if (currentObject === undefined)
                break;
        }
        return currentObject;
    }

    public static setCachedKeys(keys: any) {
        if (!this.configuration)
            this.configuration = {};
        this.configuration.cachedKeys = keys;
        this.cachedKeys = keys;
    }

    public static isDataExits() {
        return this.configuration != undefined;
    }

    private static configuration: any;
    private static cachedKeys: any
}


// WEBPACK FOOTER //
// ./node_modules/@rx/core/applicationconfiguration.ts